import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=ea20b86e&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=js&"
export * from "./TaskDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=ea20b86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea20b86e",
  null
  
)

export default component.exports